export default {
  name: 'FapiaoFAQ',
  methods: {
    onChangeClick() {
      window.open("https://inv-veri.chinatax.gov.cn");
    }
  }
};